import { render, staticRenderFns } from "./SexTypeStatisticsChart.vue?vue&type=template&id=2bb98331&scoped=true"
import script from "./SexTypeStatisticsChart.vue?vue&type=script&lang=js"
export * from "./SexTypeStatisticsChart.vue?vue&type=script&lang=js"
import style0 from "./SexTypeStatisticsChart.vue?vue&type=style&index=0&id=2bb98331&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb98331",
  null
  
)

export default component.exports